// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/services/atividadeService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type {
  AtividadeResumo,
  AtividadeDetalhe,
  CriarAtividadeRequest,
  AtualizarAtividadeRequest,
  AtividadeFiltros,
  PaginadoResponse,
} from '../types';

const BASE = '/api/atividades';

export const atividadeService = {
  /** Lista inteira (array), sem paginação. */
  async getAll(filtros: AtividadeFiltros = {}): Promise<AtividadeResumo[]> {
    const { data } = await apiClient.get<AtividadeResumo[]>(BASE, { params: filtros });
    return data;
  },

  /** Lista paginada; filtros, busca, período (yyyy-MM-dd) e ordem são feitos no servidor. */
  async getPaginado(
    pagina = 1,
    tamanhoPagina = 20,
    filtros: AtividadeFiltros = {},
  ): Promise<PaginadoResponse<AtividadeResumo>> {
    const { data } = await apiClient.get<PaginadoResponse<AtividadeResumo>>(BASE, {
      params: {
        ...filtros,
        busca: filtros.busca?.trim() || undefined,
        dtInicio: filtros.dtInicio || undefined,
        dtFim: filtros.dtFim || undefined,
        pagina, tamanhoPagina,
      },
    });
    return data;
  },

  async getById(id: number): Promise<AtividadeDetalhe> {
    const { data } = await apiClient.get<AtividadeDetalhe>(`${BASE}/${id}`);
    return data;
  },

  async create(request: CriarAtividadeRequest): Promise<AtividadeDetalhe> {
    const { data } = await apiClient.post<AtividadeDetalhe>(BASE, request);
    return data;
  },

  async update(id: number, request: AtualizarAtividadeRequest): Promise<AtividadeDetalhe> {
    const { data } = await apiClient.put<AtividadeDetalhe>(`${BASE}/${id}`, request);
    return data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },
};
